<mat-form-field>
    <mat-label>Publication Configuration</mat-label>
<mat-select formControlName="configuration" value="default" (valueChange)="onPublicationConfigurationChange($event)">
    @for (id of project.publicationConfigurations.keys(); track id) {
        <mat-option [value]="id">{{id}}</mat-option>
    }
</mat-select>
</mat-form-field>